<script setup lang="ts">
import { aboutDialogInjectionKey } from '@/components/AboutDialog/utils';
import { injectStrict } from '@/utils/injectStrict';

interface SimplePagePops {
  headline?: string;
}

const { isOpen } = injectStrict(aboutDialogInjectionKey);

defineProps<SimplePagePops>();
</script>

<template>
  <h3 v-if="headline" class="mb-6">{{ headline }}</h3>

  <slot />
  <div class="mt-10">
    <GhostVBtn :text="$t('AboutPtw100')" size="x-small" @click="isOpen = true" />
  </div>
</template>
